/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/gitlab.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { DevOpsServiceSetRuntimeFlagBody } from '../models'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerCreateFeatureEnvironmentRequest } from '../models'
// @ts-ignore
import type { TrackerCreateReleaseRequest } from '../models'
// @ts-ignore
import type { TrackerDeleteFeatureEnvironmentRequest } from '../models'
// @ts-ignore
import type { TrackerDevOpsActionResponse } from '../models'
// @ts-ignore
import type { TrackerGenerateReleaseNotesRequest } from '../models'
// @ts-ignore
import type { TrackerGenerateReleaseNotesResponse } from '../models'
// @ts-ignore
import type { TrackerListDevOpsActionsResponse } from '../models'
// @ts-ignore
import type { TrackerListFeatureStandsResponse } from '../models'
// @ts-ignore
import type { TrackerListReleaseServicesResponse } from '../models'
// @ts-ignore
import type { TrackerListRepositoriesResponse } from '../models'
// @ts-ignore
import type { TrackerListRuntimeFlagsResponse } from '../models'
// @ts-ignore
import type { TrackerRaiseFeatureStandRequest } from '../models'
// @ts-ignore
import type { TrackerRepositoryResponse } from '../models'
// @ts-ignore
import type { TrackerStopFeatureStandRequest } from '../models'
// @ts-ignore
import type { TrackerSyncRepositoriesResponse } from '../models'
/**
 * DevOpsServiceApi - axios parameter creator
 */
export const DevOpsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Puts the webhook on one repository, or repairs the one that is there.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceConnectRepository: async (
      gitlabProjectId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'gitlabProjectId' is not null or undefined
      assertParamExists('devOpsServiceConnectRepository', 'gitlabProjectId', gitlabProjectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceConnectRepository', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/repositories/{gitlabProjectId}:connect`.replace(
        '{gitlabProjectId}',
        encodeURIComponent(String(gitlabProjectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Raises a feature environment for a branch — the vp-f-dev-NNNN stand.
     * @param {TrackerCreateFeatureEnvironmentRequest} body Raise a stand for a branch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceCreateFeatureEnvironment: async (
      body: TrackerCreateFeatureEnvironmentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceCreateFeatureEnvironment', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/feature-environments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Tags a release: the semver tag that starts the production pipeline.
     * @param {TrackerCreateReleaseRequest} body Tag a release.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceCreateRelease: async (
      body: TrackerCreateReleaseRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceCreateRelease', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/releases`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Tears a feature environment down.
     * @param {TrackerDeleteFeatureEnvironmentRequest} body Tear a stand down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceDeleteFeatureEnvironment: async (
      body: TrackerDeleteFeatureEnvironmentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceDeleteFeatureEnvironment', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/feature-environments:delete`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes the webhook. The repository stays in the list, muted.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceDisconnectRepository: async (
      gitlabProjectId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'gitlabProjectId' is not null or undefined
      assertParamExists('devOpsServiceDisconnectRepository', 'gitlabProjectId', gitlabProjectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceDisconnectRepository', 'body', body)
      const localVarPath =
        `/api/v1/tracker/devops/repositories/{gitlabProjectId}:disconnect`.replace(
          '{gitlabProjectId}',
          encodeURIComponent(String(gitlabProjectId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary A draft of the release description, written by the assistant from what landed on master after the last release tag. A draft: the tag is cut by a human, who reads the text first.
     * @param {TrackerGenerateReleaseNotesRequest} body Which repository to write the release description for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceGenerateReleaseNotes: async (
      body: TrackerGenerateReleaseNotesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceGenerateReleaseNotes', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/releases:generate-notes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary The audit log: who did what, and how it ended.
     * @param {string} [issueId] Actions of one task. Empty means all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListDevOpsActions: async (
      issueId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/devops/actions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (issueId !== undefined) {
        localVarQueryParameter['issueId'] = issueId
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Live feature stands, as GitLab environments know them: what is up right now, at which addresses, and when it tears itself down (DEV-1627).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListFeatureStands: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/devops/feature-stands`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Services a release should probably cover: the ones the tasks of an epic reached through merge requests. A hint, not a decision.
     * @param {string} epicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListReleaseServices: async (
      epicId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'epicId' is not null or undefined
      assertParamExists('devOpsServiceListReleaseServices', 'epicId', epicId)
      const localVarPath = `/api/v1/tracker/devops/release-services/{epicId}`.replace(
        '{epicId}',
        encodeURIComponent(String(epicId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Repositories the tracker listens to, with the state of each webhook.
     * @param {DevOpsServiceListRepositoriesStateEnum} [state] Keep only repositories in this webhook state. Empty means all of them.   - WEBHOOK_STATE_CONNECTED: The hook is there and points at us.  - WEBHOOK_STATE_MISSING: No hook of ours on this repository yet — a new one, or someone deleted it.  - WEBHOOK_STATE_FAILED: The hook exists but GitLab refused it, or we could not reach the project.  - WEBHOOK_STATE_MUTED: Deliberately left alone: someone disconnected it by hand.
     * @param {string} [search] Substring of the path: backend, tracker-vue. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListRepositories: async (
      state?: DevOpsServiceListRepositoriesStateEnum,
      search?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/devops/repositories`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (state !== undefined) {
        localVarQueryParameter['state'] = state
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Runtime flags as they stand right now.
     * @param {string} [environment] dev or prod.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListRuntimeFlags: async (
      environment?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/devops/runtime-flags`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (environment !== undefined) {
        localVarQueryParameter['environment'] = environment
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Raises a stand from the services of a task: every one of them into a single namespace. A backend without its frontend is nothing to look at, so the stand is raised as a set, not one repository at a time (DEV-1628).
     * @param {TrackerRaiseFeatureStandRequest} body Which task to raise a stand for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceRaiseFeatureStand: async (
      body: TrackerRaiseFeatureStandRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceRaiseFeatureStand', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/feature-stands`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Turns a runtime flag on or off.
     * @param {string} key
     * @param {DevOpsServiceSetRuntimeFlagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceSetRuntimeFlag: async (
      key: string,
      body: DevOpsServiceSetRuntimeFlagBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists('devOpsServiceSetRuntimeFlag', 'key', key)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceSetRuntimeFlag', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/runtime-flags/{key}`.replace(
        '{key}',
        encodeURIComponent(String(key)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Tears a whole stand down — every environment carrying that number. The namespace is shared, so stopping one repository would leave the rest pointing at a stand that no longer exists.
     * @param {TrackerStopFeatureStandRequest} body Which stand to tear down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceStopFeatureStand: async (
      body: TrackerStopFeatureStandRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceStopFeatureStand', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/feature-stands:stop`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Runs the same reconciliation the background worker runs, right now.
     * @param {object} body Nothing to ask: the reconciliation covers the whole group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceSyncRepositories: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('devOpsServiceSyncRepositories', 'body', body)
      const localVarPath = `/api/v1/tracker/devops/repositories:sync`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DevOpsServiceApi - functional programming interface
 */
export const DevOpsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DevOpsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Puts the webhook on one repository, or repairs the one that is there.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceConnectRepository(
      gitlabProjectId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerRepositoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceConnectRepository(
        gitlabProjectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceConnectRepository']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Raises a feature environment for a branch — the vp-f-dev-NNNN stand.
     * @param {TrackerCreateFeatureEnvironmentRequest} body Raise a stand for a branch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceCreateFeatureEnvironment(
      body: TrackerCreateFeatureEnvironmentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.devOpsServiceCreateFeatureEnvironment(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceCreateFeatureEnvironment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Tags a release: the semver tag that starts the production pipeline.
     * @param {TrackerCreateReleaseRequest} body Tag a release.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceCreateRelease(
      body: TrackerCreateReleaseRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceCreateRelease(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceCreateRelease']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Tears a feature environment down.
     * @param {TrackerDeleteFeatureEnvironmentRequest} body Tear a stand down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceDeleteFeatureEnvironment(
      body: TrackerDeleteFeatureEnvironmentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.devOpsServiceDeleteFeatureEnvironment(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceDeleteFeatureEnvironment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes the webhook. The repository stays in the list, muted.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceDisconnectRepository(
      gitlabProjectId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerRepositoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceDisconnectRepository(
        gitlabProjectId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceDisconnectRepository']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary A draft of the release description, written by the assistant from what landed on master after the last release tag. A draft: the tag is cut by a human, who reads the text first.
     * @param {TrackerGenerateReleaseNotesRequest} body Which repository to write the release description for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceGenerateReleaseNotes(
      body: TrackerGenerateReleaseNotesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TrackerGenerateReleaseNotesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceGenerateReleaseNotes(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceGenerateReleaseNotes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary The audit log: who did what, and how it ended.
     * @param {string} [issueId] Actions of one task. Empty means all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceListDevOpsActions(
      issueId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListDevOpsActionsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceListDevOpsActions(
        issueId,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceListDevOpsActions']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Live feature stands, as GitLab environments know them: what is up right now, at which addresses, and when it tears itself down (DEV-1627).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceListFeatureStands(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListFeatureStandsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.devOpsServiceListFeatureStands(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceListFeatureStands']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Services a release should probably cover: the ones the tasks of an epic reached through merge requests. A hint, not a decision.
     * @param {string} epicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceListReleaseServices(
      epicId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListReleaseServicesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceListReleaseServices(
        epicId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceListReleaseServices']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Repositories the tracker listens to, with the state of each webhook.
     * @param {DevOpsServiceListRepositoriesStateEnum} [state] Keep only repositories in this webhook state. Empty means all of them.   - WEBHOOK_STATE_CONNECTED: The hook is there and points at us.  - WEBHOOK_STATE_MISSING: No hook of ours on this repository yet — a new one, or someone deleted it.  - WEBHOOK_STATE_FAILED: The hook exists but GitLab refused it, or we could not reach the project.  - WEBHOOK_STATE_MUTED: Deliberately left alone: someone disconnected it by hand.
     * @param {string} [search] Substring of the path: backend, tracker-vue. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceListRepositories(
      state?: DevOpsServiceListRepositoriesStateEnum,
      search?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListRepositoriesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceListRepositories(
        state,
        search,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceListRepositories']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Runtime flags as they stand right now.
     * @param {string} [environment] dev or prod.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceListRuntimeFlags(
      environment?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListRuntimeFlagsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceListRuntimeFlags(
        environment,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceListRuntimeFlags']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Raises a stand from the services of a task: every one of them into a single namespace. A backend without its frontend is nothing to look at, so the stand is raised as a set, not one repository at a time (DEV-1628).
     * @param {TrackerRaiseFeatureStandRequest} body Which task to raise a stand for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceRaiseFeatureStand(
      body: TrackerRaiseFeatureStandRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceRaiseFeatureStand(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceRaiseFeatureStand']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Turns a runtime flag on or off.
     * @param {string} key
     * @param {DevOpsServiceSetRuntimeFlagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceSetRuntimeFlag(
      key: string,
      body: DevOpsServiceSetRuntimeFlagBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceSetRuntimeFlag(
        key,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceSetRuntimeFlag']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Tears a whole stand down — every environment carrying that number. The namespace is shared, so stopping one repository would leave the rest pointing at a stand that no longer exists.
     * @param {TrackerStopFeatureStandRequest} body Which stand to tear down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceStopFeatureStand(
      body: TrackerStopFeatureStandRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerDevOpsActionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceStopFeatureStand(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceStopFeatureStand']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Runs the same reconciliation the background worker runs, right now.
     * @param {object} body Nothing to ask: the reconciliation covers the whole group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async devOpsServiceSyncRepositories(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerSyncRepositoriesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.devOpsServiceSyncRepositories(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DevOpsServiceApi.devOpsServiceSyncRepositories']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DevOpsServiceApi - factory interface
 */
export const DevOpsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DevOpsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Puts the webhook on one repository, or repairs the one that is there.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceConnectRepository(
      gitlabProjectId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerRepositoryResponse> {
      return localVarFp
        .devOpsServiceConnectRepository(gitlabProjectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Raises a feature environment for a branch — the vp-f-dev-NNNN stand.
     * @param {TrackerCreateFeatureEnvironmentRequest} body Raise a stand for a branch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceCreateFeatureEnvironment(
      body: TrackerCreateFeatureEnvironmentRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceCreateFeatureEnvironment(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Tags a release: the semver tag that starts the production pipeline.
     * @param {TrackerCreateReleaseRequest} body Tag a release.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceCreateRelease(
      body: TrackerCreateReleaseRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceCreateRelease(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Tears a feature environment down.
     * @param {TrackerDeleteFeatureEnvironmentRequest} body Tear a stand down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceDeleteFeatureEnvironment(
      body: TrackerDeleteFeatureEnvironmentRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceDeleteFeatureEnvironment(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes the webhook. The repository stays in the list, muted.
     * @param {string} gitlabProjectId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceDisconnectRepository(
      gitlabProjectId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerRepositoryResponse> {
      return localVarFp
        .devOpsServiceDisconnectRepository(gitlabProjectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary A draft of the release description, written by the assistant from what landed on master after the last release tag. A draft: the tag is cut by a human, who reads the text first.
     * @param {TrackerGenerateReleaseNotesRequest} body Which repository to write the release description for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceGenerateReleaseNotes(
      body: TrackerGenerateReleaseNotesRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerGenerateReleaseNotesResponse> {
      return localVarFp
        .devOpsServiceGenerateReleaseNotes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary The audit log: who did what, and how it ended.
     * @param {string} [issueId] Actions of one task. Empty means all of them.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListDevOpsActions(
      issueId?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListDevOpsActionsResponse> {
      return localVarFp
        .devOpsServiceListDevOpsActions(issueId, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Live feature stands, as GitLab environments know them: what is up right now, at which addresses, and when it tears itself down (DEV-1627).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListFeatureStands(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListFeatureStandsResponse> {
      return localVarFp
        .devOpsServiceListFeatureStands(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Services a release should probably cover: the ones the tasks of an epic reached through merge requests. A hint, not a decision.
     * @param {string} epicId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListReleaseServices(
      epicId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListReleaseServicesResponse> {
      return localVarFp
        .devOpsServiceListReleaseServices(epicId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Repositories the tracker listens to, with the state of each webhook.
     * @param {DevOpsServiceListRepositoriesStateEnum} [state] Keep only repositories in this webhook state. Empty means all of them.   - WEBHOOK_STATE_CONNECTED: The hook is there and points at us.  - WEBHOOK_STATE_MISSING: No hook of ours on this repository yet — a new one, or someone deleted it.  - WEBHOOK_STATE_FAILED: The hook exists but GitLab refused it, or we could not reach the project.  - WEBHOOK_STATE_MUTED: Deliberately left alone: someone disconnected it by hand.
     * @param {string} [search] Substring of the path: backend, tracker-vue. Empty means all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListRepositories(
      state?: DevOpsServiceListRepositoriesStateEnum,
      search?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListRepositoriesResponse> {
      return localVarFp
        .devOpsServiceListRepositories(state, search, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Runtime flags as they stand right now.
     * @param {string} [environment] dev or prod.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceListRuntimeFlags(
      environment?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListRuntimeFlagsResponse> {
      return localVarFp
        .devOpsServiceListRuntimeFlags(environment, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Raises a stand from the services of a task: every one of them into a single namespace. A backend without its frontend is nothing to look at, so the stand is raised as a set, not one repository at a time (DEV-1628).
     * @param {TrackerRaiseFeatureStandRequest} body Which task to raise a stand for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceRaiseFeatureStand(
      body: TrackerRaiseFeatureStandRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceRaiseFeatureStand(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Turns a runtime flag on or off.
     * @param {string} key
     * @param {DevOpsServiceSetRuntimeFlagBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceSetRuntimeFlag(
      key: string,
      body: DevOpsServiceSetRuntimeFlagBody,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceSetRuntimeFlag(key, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Tears a whole stand down — every environment carrying that number. The namespace is shared, so stopping one repository would leave the rest pointing at a stand that no longer exists.
     * @param {TrackerStopFeatureStandRequest} body Which stand to tear down.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceStopFeatureStand(
      body: TrackerStopFeatureStandRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerDevOpsActionResponse> {
      return localVarFp
        .devOpsServiceStopFeatureStand(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Runs the same reconciliation the background worker runs, right now.
     * @param {object} body Nothing to ask: the reconciliation covers the whole group.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    devOpsServiceSyncRepositories(
      body: object,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerSyncRepositoriesResponse> {
      return localVarFp
        .devOpsServiceSyncRepositories(body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DevOpsServiceApi - object-oriented interface
 */
export class DevOpsServiceApi extends BaseAPI {
  /**
   *
   * @summary Puts the webhook on one repository, or repairs the one that is there.
   * @param {string} gitlabProjectId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceConnectRepository(
    gitlabProjectId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceConnectRepository(gitlabProjectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Raises a feature environment for a branch — the vp-f-dev-NNNN stand.
   * @param {TrackerCreateFeatureEnvironmentRequest} body Raise a stand for a branch.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceCreateFeatureEnvironment(
    body: TrackerCreateFeatureEnvironmentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceCreateFeatureEnvironment(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Tags a release: the semver tag that starts the production pipeline.
   * @param {TrackerCreateReleaseRequest} body Tag a release.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceCreateRelease(
    body: TrackerCreateReleaseRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceCreateRelease(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Tears a feature environment down.
   * @param {TrackerDeleteFeatureEnvironmentRequest} body Tear a stand down.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceDeleteFeatureEnvironment(
    body: TrackerDeleteFeatureEnvironmentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceDeleteFeatureEnvironment(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes the webhook. The repository stays in the list, muted.
   * @param {string} gitlabProjectId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceDisconnectRepository(
    gitlabProjectId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceDisconnectRepository(gitlabProjectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary A draft of the release description, written by the assistant from what landed on master after the last release tag. A draft: the tag is cut by a human, who reads the text first.
   * @param {TrackerGenerateReleaseNotesRequest} body Which repository to write the release description for.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceGenerateReleaseNotes(
    body: TrackerGenerateReleaseNotesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceGenerateReleaseNotes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary The audit log: who did what, and how it ended.
   * @param {string} [issueId] Actions of one task. Empty means all of them.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceListDevOpsActions(
    issueId?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceListDevOpsActions(issueId, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Live feature stands, as GitLab environments know them: what is up right now, at which addresses, and when it tears itself down (DEV-1627).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceListFeatureStands(options?: RawAxiosRequestConfig) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceListFeatureStands(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Services a release should probably cover: the ones the tasks of an epic reached through merge requests. A hint, not a decision.
   * @param {string} epicId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceListReleaseServices(epicId: string, options?: RawAxiosRequestConfig) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceListReleaseServices(epicId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Repositories the tracker listens to, with the state of each webhook.
   * @param {DevOpsServiceListRepositoriesStateEnum} [state] Keep only repositories in this webhook state. Empty means all of them.   - WEBHOOK_STATE_CONNECTED: The hook is there and points at us.  - WEBHOOK_STATE_MISSING: No hook of ours on this repository yet — a new one, or someone deleted it.  - WEBHOOK_STATE_FAILED: The hook exists but GitLab refused it, or we could not reach the project.  - WEBHOOK_STATE_MUTED: Deliberately left alone: someone disconnected it by hand.
   * @param {string} [search] Substring of the path: backend, tracker-vue. Empty means all of them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceListRepositories(
    state?: DevOpsServiceListRepositoriesStateEnum,
    search?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceListRepositories(state, search, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Runtime flags as they stand right now.
   * @param {string} [environment] dev or prod.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceListRuntimeFlags(environment?: string, options?: RawAxiosRequestConfig) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceListRuntimeFlags(environment, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Raises a stand from the services of a task: every one of them into a single namespace. A backend without its frontend is nothing to look at, so the stand is raised as a set, not one repository at a time (DEV-1628).
   * @param {TrackerRaiseFeatureStandRequest} body Which task to raise a stand for.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceRaiseFeatureStand(
    body: TrackerRaiseFeatureStandRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceRaiseFeatureStand(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Turns a runtime flag on or off.
   * @param {string} key
   * @param {DevOpsServiceSetRuntimeFlagBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceSetRuntimeFlag(
    key: string,
    body: DevOpsServiceSetRuntimeFlagBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceSetRuntimeFlag(key, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Tears a whole stand down — every environment carrying that number. The namespace is shared, so stopping one repository would leave the rest pointing at a stand that no longer exists.
   * @param {TrackerStopFeatureStandRequest} body Which stand to tear down.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceStopFeatureStand(
    body: TrackerStopFeatureStandRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceStopFeatureStand(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Runs the same reconciliation the background worker runs, right now.
   * @param {object} body Nothing to ask: the reconciliation covers the whole group.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public devOpsServiceSyncRepositories(body: object, options?: RawAxiosRequestConfig) {
    return DevOpsServiceApiFp(this.configuration)
      .devOpsServiceSyncRepositories(body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const DevOpsServiceListRepositoriesStateEnum = {
  WebhookStateInvalid: 'WEBHOOK_STATE_INVALID',
  WebhookStateConnected: 'WEBHOOK_STATE_CONNECTED',
  WebhookStateMissing: 'WEBHOOK_STATE_MISSING',
  WebhookStateFailed: 'WEBHOOK_STATE_FAILED',
  WebhookStateMuted: 'WEBHOOK_STATE_MUTED',
} as const
export type DevOpsServiceListRepositoriesStateEnum =
  (typeof DevOpsServiceListRepositoriesStateEnum)[keyof typeof DevOpsServiceListRepositoriesStateEnum]
